import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4aadfd70")

_pushScopeId("data-v-4aadfd70")
const _hoisted_1 = {
  class: "flex w-full justify-between items-center pb-5",
  style: {"border-bottom":"1px solid #CFD8DC"}
}
const _hoisted_2 = { class: "font-semibold text-xl text-black" }
const _hoisted_3 = { class: "py-1 field" }
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = { class: " font-semibold text-black text-sm" }
const _hoisted_6 = {
  for: "nominalId",
  class: "color-blue-grey",
  style: {"font-size":"10px"}
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "p-error"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "p-error"
}
const _hoisted_11 = { key: 2 }
const _hoisted_12 = {
  key: 0,
  class: "p-error"
}
const _hoisted_13 = { class: "flex gap-4 justify-start" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Kembali")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isShowModal,
    "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => (_ctx.isShowModal = $event)),
    dismissableMask: true,
    modal: true,
    style: {width: '40vw'},
    onHide: _cache[7] || (_cache[7] = ($event: any) => (_ctx.hideDialog())),
    class: ["dialog-confirm", _ctx.typeForm === 'ChangeDiscountLevel' ? 'discLevel' : '' ]
  }, {
    header: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("h6", _hoisted_2, _toDisplayString(_ctx.titleModal), 1),
        _createVNode("i", {
          class: "pi pi-times text-black cursor-pointer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideDialog()))
        })
      ])
    ]),
    footer: _withId(() => [
      _createVNode("div", _hoisted_13, [
        _createVNode(_component_Button, {
          class: "btn-primary font-semibold px-10 text-white",
          type: "submit",
          form: "form-change"
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.textBtn), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          class: "btn-secondary text-black font-semibold px-10 py-1",
          type: "button",
          onClick: _ctx.hideDialog
        }, {
          default: _withId(() => [
            _hoisted_14
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withId(() => [
      _createVNode("section", _hoisted_3, [
        (_ctx.showForm)
          ? (_openBlock(), _createBlock("form", {
              key: 0,
              id: "form-change",
              onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.submitData(!_ctx.v$.$invalid)), ["prevent"]))
            }, [
              _createVNode("div", _hoisted_4, [
                _createVNode("p", _hoisted_5, _toDisplayString(_ctx.descriptionModal), 1)
              ]),
              _createVNode("div", null, [
                _createVNode("label", _hoisted_6, _toDisplayString(_ctx.labelInput), 1),
                (_ctx.typeForm === 'ChangeDiscountLevel')
                  ? (_openBlock(), _createBlock("div", _hoisted_7, [
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.v$.level.$model,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.level.$model = $event)),
                        searchable: true,
                        class: "input-grey rounded-lg w-full mt-1 mb-2",
                        id: "nominalId",
                        label: "label",
                        valueProp: "value",
                        options: _ctx.levelDiskon,
                        placeholder: "Pilih Level Diskon"
                      }, null, 8, ["modelValue", "options"]),
                      ((_ctx.v$.level.$invalid && _ctx.submitted) || _ctx.v$.level.$pending.$response)
                        ? (_openBlock(), _createBlock("small", _hoisted_8, _toDisplayString(_ctx.v$.level.required.$message), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : (_ctx.typeForm === 'ChangeCutoffDate')
                    ? (_openBlock(), _createBlock("div", _hoisted_9, [
                        _createVNode(_component_InputNumber, {
                          modelValue: _ctx.v$.tglCutoff.$model,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.tglCutoff.$model = $event)),
                          id: "nominalId",
                          class: "input-primary rounded-lg w-full mt-1",
                          showButtons: "",
                          buttonLayout: "horizontal",
                          incrementButtonIcon: "pi pi-plus",
                          decrementButtonIcon: "pi pi-minus",
                          min: 1,
                          max: 28
                        }, null, 8, ["modelValue"]),
                        ((_ctx.v$.tglCutoff.$invalid && _ctx.submitted) || _ctx.v$.tglCutoff.$pending.$response)
                          ? (_openBlock(), _createBlock("small", _hoisted_10, _toDisplayString(_ctx.v$.tglCutoff.required.$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_11, [
                        _createVNode(_component_InputNumber, {
                          id: "nominalId",
                          class: "input-grey rounded-lg w-full mt-1",
                          placeholder: "0",
                          mode: "currency",
                          currency: "IDR",
                          locale: "id-ID",
                          modelValue: _ctx.v$.nominal.$model,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.nominal.$model = $event))
                        }, null, 8, ["modelValue"]),
                        ((_ctx.v$.nominal.$invalid && _ctx.submitted) || _ctx.v$.nominal.$pending.$response)
                          ? (_openBlock(), _createBlock("small", _hoisted_12, _toDisplayString(_ctx.v$.nominal.required.$message), 1))
                          : _createCommentVNode("", true)
                      ]))
              ])
            ], 32))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["visible", "class"]))
})